import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.27273 7.54545C2.97564 7.54545 3.54545 6.97564 3.54545 6.27273C3.54545 5.56982 2.97564 5 2.27273 5C1.56982 5 1 5.56982 1 6.27273C1 6.97564 1.56982 7.54545 2.27273 7.54545ZM22 7.27273H5.45455V5.27273H22V7.27273ZM22 11.2273H7.36364V10.2273H22V11.2273ZM22 15.0455H7.36364V14.0455H22V15.0455ZM7.36364 18.8636H22V17.8636H7.36364V18.8636Z",
		fill: "currentColor"
	})
});
export default SvgIconSection;
